// Flat AI review fee by room CAPACITY (max players), not current players.
// Kept identical to the mobile app's getAiReviewCost (components/GameSettings.tsx).
export const AI_REVIEW_TIERS = [
  { maxPlayers: 5, cost: 100 },
  { maxPlayers: 10, cost: 200 },
];
export const AI_REVIEW_TOP_COST = 350;

export function getAiReviewCost(maxPlayers) {
  const tier = AI_REVIEW_TIERS.find((t) => maxPlayers <= t.maxPlayers);
  return tier ? tier.cost : AI_REVIEW_TOP_COST;
}
